const EventDataManagementModalHOC = props => {
    return props.children;
}

export default EventDataManagementModalHOC;
